import {
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_AGUARDANDO_EXTRATO,
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_NEGADO,
} from '../../../library/ContratoStatus';

export const PUFVCentralPermissions = {
  id: 'pufv_central',

  navbar: {
    view: true,
    profile: {
      edit: false,
      perfilBeta: false,
    },
  },

  projetos: {
    list: true,
    register: true,
    edit: true,
    approve: true,
    reprove: true,
    editFinished: false,
    remove: false,
    viewChecker: {
      professorGestor: false,
      coordenadorLocal: false,
    },
    filters: {
      situacao: true,
      coop: true,
    },
  },

  reembolsos: {
    list: true,
    register: true,
    edit: true,
    remove: true,
  },

  professores: {
    list: true,
    register: true,
    edit: true,
    approve: true,
    reprove: true,
    activate: true,
    deactivate: true,
    canRemove: false,
  },

  assessores: {
    list: true,
    register: true,
    edit: true,
    activate: true,
    deactivate: true,
    canRemove: false,
  },

  coordenadores: {
    list: true,
    register: true,
    edit: true,
    activate: true,
    deactivate: true,
    canRemove: false,
  },

  empresas: {
    list: true,
    register: true,
    edit: true,
    remove: true,
  },

  escolas: {
    list: true,
    register: true,
    edit: true,
    activate: true,
    deactivate: true,
    dadosDaEscola: {
      list: true,
      register: true,
      edit: true,
      duplicate: true,
      remove: true,
    },
    ideb: {
      list: true,
      register: true,
      edit: true,
      remove: true,
    },
  },

  relatorios: {
    generate: {
      projetos: true,
      'dados-cadastrais': true,
      'dados-gerais': true,
      'dados-do-programa': true,
      assessoria: true,
      'dados-do-ideb': true,
      contratos: true,
      escolas: true,
    },
  },

  materiaisPedagogicos: {
    list: true,
    download: true,
  },

  agendaAssessoresPedagogicos: {
    list: true,
    register: true,
    edit: {
      locked: false,
      unlocked: true,
    },
    lock: true,
    unlock: true,
    remove: [true, true, true, true, true],
  },

  dashboard: {
    generate: true,
  },

  contratos: {
    list: true,
    editEvenWhenDisabled: false,
    assessor: {
      allStatus: [
        CONTRATO_STATUS_EM_EDICAO,
        CONTRATO_STATUS_EM_ANALISE,
        CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
        CONTRATO_STATUS_NAO_INICIADO,
        CONTRATO_STATUS_VIGENTE,
        CONTRATO_STATUS_ENCERRADO,
        CONTRATO_STATUS_DESATIVADO,
      ],
      edit: true,
      register: true,
      view: true,
      upload: true,
      changeUpload: false,
      changeStatus: true,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
    entePublico: {
      allStatus: [
        CONTRATO_STATUS_EM_EDICAO,
        CONTRATO_STATUS_EM_ANALISE,
        CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
        CONTRATO_STATUS_NAO_INICIADO,
        CONTRATO_STATUS_VIGENTE,
        CONTRATO_STATUS_ENCERRADO,
        CONTRATO_STATUS_DESATIVADO,
        CONTRATO_STATUS_AGUARDANDO_EXTRATO,
        CONTRATO_STATUS_APROVADO,
        CONTRATO_STATUS_NEGADO,
      ],
      downloadChecklist: true,
      edit: true,
      register: true,
      view: true,
      uploadNaoAssinado: true,
      uploadAssinado: true,
      uploadExtrato: true,
      changeUploadAssinado: false,
      changeUploadExtrato: false,
      changeUploadPlanoTrabalho: false,
      changeStatus: true,
      analiseOperacional: {
        edit: false,
      },
    },
    entePrivado: {
      allStatus: [
        CONTRATO_STATUS_EM_EDICAO,
        CONTRATO_STATUS_EM_ANALISE,
        CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
        CONTRATO_STATUS_NAO_INICIADO,
        CONTRATO_STATUS_VIGENTE,
        CONTRATO_STATUS_ENCERRADO,
        CONTRATO_STATUS_DESATIVADO,
      ],
      edit: true,
      register: true,
      view: true,
      upload: true,
      changeUpload: false,
      changeStatus: true,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
  },
};
